import React from 'react'
import '../../components/nav-bar/style.css'
import { LoginForm } from "../../components"


export function LoginPage() {
    
    return (
        <div className="LoginPage">
            <LoginForm />
        </div>
    )
}
